import { useMemo as t } from "react";
import a from "dayjs";
const d = (t2) => Array.from({ length: t2 }, (t3, a2) => a2 + 1), e = (t2) => t2 ? t2 - 1 : 6, r = (t2) => {
  const r2 = a(t2), n2 = e(r2.startOf("month").day()), o = e(r2.endOf("month").day()), m = r2.endOf("month").date();
  return [...(n2 ? d(n2).map((t3, a2) => r2.add(-1, "month").endOf("month").date() - a2) : []).toReversed().map((t3) => ({ dayNumber: t3, date: r2.startOf("day").add(-1, "month").set("date", t3), isCurrentMonth: false, isPreviousMonth: true })), ...d(m).map((t3) => ({ dayNumber: t3, date: r2.startOf("day").set("date", t3), isCurrentMonth: true })), ...(o ? d(6 - o).map((t3, a2) => r2.add(1, "month").startOf("month").date() + a2) : []).map((t3) => ({ dayNumber: t3, date: r2.startOf("day").add(1, "month").set("date", t3), isCurrentMonth: false, isNextMonth: true }))].map((t3, a2) => ({ ...t3, index: a2 }));
}, n = (a2) => t(() => r(a2), [a2]);
export {
  d as createArray,
  n as default,
  r as generateCalendarCells,
  e as getDayOfWeek
};
//# sourceMappingURL=useCalendarCells.js.map
